import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OpenService } from '@app-services/open.service';
import { MarketPlacePersonalizationUtils } from '@app-components/layouts/shopkeeper-layout/marketplace-personalization';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dialog-already-sbx-account',
  templateUrl: './dialog-already-sbx-account.component.html',
  styleUrls: ['./dialog-already-sbx-account.component.scss']
})
export class DialogAlreadySbxAccountComponent implements OnInit {
  callbackUrl = `${window.location.protocol}//${window.location.host}/authorization/`;
  private redirectUri = '/arrematar/home'
  migrationMandatory = false;
  currentStep = 0;
  totalSteps = 2;
  selectedTabIndex = 0;
  mandatoryDate: string;

  constructor(
    public dialogRef: MatDialogRef<DialogAlreadySbxAccountComponent>,
    private openService: OpenService,
    private elRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.openService.getLayoutVars()
      .subscribe(layoutVars => {
        MarketPlacePersonalizationUtils.initCssVars(this.elRef, layoutVars);
      });
    this.migrationMandatory = data?.migrationMandatory;
    this.mandatoryDate = data?.mandatoryDate;
  }

  ngOnInit(): void { }

  backToLogin(): void {
    this.dialogRef.close();
  }

  redirectSuperbidAccounts(): void {
    const base = environment.superBidUrl;
    const action = 'signin';
    const finalUrl =
      `${base}/${action}?response_type=token&client_id=${environment.superBidClientId}` +
      `&redirect_uri=${encodeURIComponent(this.redirectUri)}` +
      `&authorization_uri=${encodeURIComponent(this.callbackUrl)}` +
      `&externalClient=true` +
      `&language=pt-BR&portal_id=2` +
      `&hostName=Superbid%20BR` +
      `&source=auto_arremate`;

    window.open(finalUrl, '_self');
  }

  close(): void {
    if (!this.migrationMandatory) {
      this.dialogRef.close();
    }
  }

  nextStep(): void {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
    }
  }
}
